import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LogoImage from '../assets/funfondowhite.png';
import LinkedInLogo from '../assets/socia-linkedin@2x.png';
import WS from '../assets/social-whatsapp@2x.png';
import { faTimes, faEnvelope, faMapMarkerAlt, faShieldAlt, faUsers, faRocket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PrivacyPolicyModal = ({ onClose }) => (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm'>
    <div className='bg-white p-8 rounded-2xl shadow-2xl max-w-4xl w-full h-[85vh] relative overflow-y-auto mx-4'>
      <div className='sticky top-0 bg-white pb-4 border-b border-gray-200'>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
        Política de Privacidad
      </h2>
        <p className='text-gray-600'>Última actualización: Enero 2024</p>
      </div>
      <div className='text-gray-700 leading-relaxed space-y-6 mt-6'>
        <div className='bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500'>
          <h3 className='font-semibold text-blue-800 mb-2'>Información que Recopilamos</h3>
          <p>
            El acceso a determinados servicios que se ofrecen en el sitio puede requerir el ingreso de datos personales, 
            a saber: dirección de e-mail, nombre, apellido, domicilio completo, tipo y número de documento y otros datos 
            opcionales, o cualquier otra información que permita individualizarlo.
          </p>
        </div>
        
        <div>
          <h3 className='font-semibold text-gray-800 mb-2'>Uso de la Información</h3>
          <p>
            Los datos que usted ingrese al Sitio se utilizarán para: envío de información sobre nuestros programas 
            formativos, mentorías y oportunidades de participación, gestión de inscripciones a cursos y talleres, 
            comunicación sobre eventos y actividades, seguimiento del progreso académico, conexión con empresas aliadas, 
            obtención de estadísticas de impacto y mejora continua de nuestros servicios.
          </p>
        </div>

        <div className='bg-green-50 p-4 rounded-lg border-l-4 border-green-500'>
          <h3 className='font-semibold text-green-800 mb-2'>Seguridad y Protección</h3>
          <p>
            Fundación HK garantiza a los usuarios que ingresen sus datos en el Sitio, que los mismos serán encriptados 
            para preservar la seguridad, integridad y confidencialidad de los datos considerados como personales. 
            El sistema de encriptado implica que los datos solo podrán ser interpretados por Fundación HK.
          </p>
        </div>

        <div>
          <h3 className='font-semibold text-gray-800 mb-2'>Sus Derechos</h3>
          <p>
            El usuario podrá acceder a sus datos de carácter personal, rectificarlos, cancelarlos u oponerse a su 
            tratamiento, mediante notificación al responsable de la base de datos{' '}
            <a href="mailto:hello@somosbackanas.com" className='text-blue-600 hover:underline'>hello@somosbackanas.com</a> (LATAM).
          </p>
        </div>

        <div className='bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500'>
          <h3 className='font-semibold text-yellow-800 mb-2'>Información Importante</h3>
          <ul className='list-disc list-inside space-y-1'>
            <li>Fundación HK no cederá esta información con terceros</li>
            <li>El usuario responderá de la veracidad de los datos facilitados</li>
            <li>Fundación HK se reserva el derecho de brindar información a organismos de control cuando sea requerido</li>
          </ul>
        </div>
      </div>
      <button
        onClick={onClose}
        className='absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200'
        aria-label="Cerrar política de privacidad"
      >
        <FontAwesomeIcon icon={faTimes} className='text-2xl' />
      </button>
    </div>
  </div>
);

const Footer = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const handlePrivacyClick = () => setShowPrivacyModal(true);
  const handleCloseModal = () => setShowPrivacyModal(false);

  return (
    <footer className='bg-gray-900 text-white relative overflow-hidden'>
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className='relative max-w-7xl mx-auto py-16 px-4'>
        {/* Main Footer Content */}
        <div className='grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12'>
          {/* Company Info */}
          <div className='lg:col-span-2'>
            <p className='text-gray-300 leading-relaxed mb-6 max-w-md'>
              Empoderamos a niñas y jóvenes a través de formación, liderazgo y oportunidades reales en áreas STEM 
              y habilidades para el futuro. Nuestra misión es acompañar, formar y vincular a jóvenes con el mundo 
              académico y laboral, promoviendo el desarrollo de habilidades y la inserción profesional.
            </p>
            <div className='flex space-x-4'>
              <a 
                href="https://cl.linkedin.com/company/somosbackanas" 
                target="_blank" 
                rel="noopener noreferrer" 
                className='bg-white bg-opacity-10 hover:bg-opacity-20 p-3 rounded-full transition-all duration-300 transform hover:scale-110'
                aria-label="Síguenos en LinkedIn"
              >
                <img src={LinkedInLogo} alt="LinkedIn" className='w-5 h-5' />
              </a>
              <a 
                href="https://wa.me/56988030121" 
                target="_blank" 
                rel="noopener noreferrer" 
                className='bg-white bg-opacity-10 hover:bg-opacity-20 p-3 rounded-full transition-all duration-300 transform hover:scale-110'
                aria-label="Contáctenme por WhatsApp"
              >
                <img src={WS} alt="WhatsApp" className='w-5 h-5' />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className='text-xl font-bold mb-6 flex items-center'>
              <FontAwesomeIcon icon={faRocket} className='mr-2 text-blue-400' />
              Enlaces Rápidos
            </h3>
            <ul className='space-y-3'>
              <li>
                <Link to="/home" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/quienes-somos" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Quiénes Somos
                </Link>
              </li>
              <li>
                <Link to="/nuestros-programas" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Nuestros Programas
                </Link>
              </li>
              <li>
                <Link to="/colegios" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Colegios
                </Link>
              </li>
              <li>
                <Link to="/alianzas" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Alianzas
                </Link>
              </li>
              <li>
                <Link to="/contacto" className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'>
                  <span className='w-2 h-2 bg-blue-400 rounded-full mr-3'></span>
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className='text-xl font-bold mb-6 flex items-center'>
              <FontAwesomeIcon icon={faUsers} className='mr-2 text-blue-400' />
              Contacto
            </h3>
            <div className='space-y-5 text-gray-300'>
              <div>
                <p className='uppercase tracking-wide text-sm text-gray-400'>Email General</p>
                <div className='flex items-center mt-1'>
                <FontAwesomeIcon icon={faEnvelope} className='text-blue-400 mr-3 w-4' />
                <a 
                    href="mailto:contacto@fundacionhk.com" 
                    className='hover:text-white transition-colors duration-200'
                >
                    contacto@fundacionhk.com
                </a>
                </div>
              </div>
              <div>
                <p className='uppercase tracking-wide text-sm text-gray-400'>Ubicación</p>
                <div className='flex items-start mt-1'>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className='text-blue-400 mr-3 w-4 mt-1' />
                  <div className='text-gray-300'>
                    <p>José Alcalde Délano 10545, Oficina 310</p>
                    <p>Lo Barnechea, Santiago, Chile</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='border-t border-gray-700 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            <div className='flex items-center space-x-6'>
              <button 
                onClick={handlePrivacyClick} 
                className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center'
                aria-label="Ver política de privacidad"
              >
                <FontAwesomeIcon icon={faShieldAlt} className='mr-2' />
                Política de Privacidad
              </button>
            </div>
            <div className='text-gray-400 text-sm'>
              © 2024 Fundación HK. Todos los derechos reservados.
            </div>
          </div>
        </div>
      </div>

      {showPrivacyModal && <PrivacyPolicyModal onClose={handleCloseModal} />}
    </footer>
  );
};

export default Footer;
